import React from 'react';
import { Checkbox, Header, Segment } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';

const UserArchivalOptions = ({
  archiveRequests,
  disabled,
  disableTokens,
  toggleRequests,
  toggleTokens,
}) => {
  const intl = useIntl();
  return (
    <Segment>
      <Header as="h5">
        <FormattedMessage id="user.archive.options" />
      </Header>
      <Checkbox
        disabled={disabled}
        className="mr-20"
        checked={disableTokens}
        label={intl.formatMessage({ id: 'user.archive.tokens.expire' })}
        onChange={disabled ? undefined : () => toggleTokens()}
      />
      <Checkbox
        disabled={disabled}
        checked={archiveRequests}
        label={intl.formatMessage({ id: 'user.archive.requests.archive' })}
        onChange={disabled ? undefined : () => toggleRequests()}
      />
    </Segment>
  );
};

export default UserArchivalOptions;
